import create from 'zustand'

type ModalStoreActions = {
  modalOpen: string
  showModal: (id: string) => void
  closeModal: () => void
}

const useModalStore = create<ModalStoreActions>(set => ({
  modalOpen: '',
  showModal: modalId => set({ modalOpen: modalId }),
  closeModal: () => set({ modalOpen: '' }),
}))

export { useModalStore }
